// Durability Info Toggle Script - Based on createdrings.com implementation
(function() {
  'use strict';

  // Get settings from global variable
  const settings = window.durabilityUpgradeSettings || {};

  // Only initialize if the feature is enabled
  if (!settings.enableInfoToggle) {
    return;
  }

  // Helpers for slide toggle
  function slideDown(el) {
    el.style.removeProperty('display');
    let display = window.getComputedStyle(el).display;
    if (display === 'none') display = 'block';
    el.style.display = display;
    const height = el.scrollHeight;
    el.style.overflow = 'hidden';
    el.style.maxHeight = '0px';
    el.offsetHeight; // force reflow
    el.style.transition = 'max-height 250ms ease';
    el.style.maxHeight = height + 'px';
    window.setTimeout(() => {
      el.style.removeProperty('max-height');
      el.style.removeProperty('overflow');
      el.style.removeProperty('transition');
      el.classList.add('active');
    }, 260);
  }

  function slideUp(el) {
    el.style.overflow = 'hidden';
    el.style.transition = 'max-height 250ms ease';
    el.style.maxHeight = el.scrollHeight + 'px';
    el.offsetHeight; // force reflow
    el.style.maxHeight = '0px';
    window.setTimeout(() => {
      el.style.display = 'none';
      el.style.removeProperty('max-height');
      el.style.removeProperty('overflow');
      el.style.removeProperty('transition');
      el.classList.remove('active');
    }, 260);
  }

  function toggleInfo(el) {
    if (!el) return;
    const isHidden = window.getComputedStyle(el).display === 'none' || el.style.display === 'none' || !el.classList.contains('active');
    if (isHidden) slideDown(el); else slideUp(el);
  }

  function buildInfoContentHTML() {
    const intro = settings.durabilityInfoText || '';
    const donut = settings.donutInfoText || '';
    const cathedral = settings.cathedralInfoText || '';
    const combo = settings.comboInfoText || '';
    const parts = [];
    if (intro) parts.push(`<p class="durability-intro">${intro}</p>`);
    parts.push('<div class="durability-options-info">');
    if (donut) parts.push(`<div class="durability-info-item"><strong>Donut:</strong> <span>${donut}</span></div>`);
    if (cathedral) parts.push(`<div class="durability-info-item"><strong>Cathedral:</strong> <span>${cathedral}</span></div>`);
    if (combo) parts.push(`<div class="durability-info-item"><strong>Combo:</strong> <span>${combo}</span></div>`);
    parts.push('</div>');
    return parts.join('');
  }

  function getOrCreateInfoPanel(referenceLabel) {
    let panel = document.getElementById('durability-info');
    if (panel) return panel;

    panel = document.createElement('div');
    panel.id = 'durability-info';
    panel.className = 'durability-info-text';
    panel.style.display = 'none';
    panel.innerHTML = buildInfoContentHTML();

    // Try native variant picker fieldset first
    const fieldset = referenceLabel ? referenceLabel.closest('fieldset[data-option-name="Durability Upgrade"]') : null;
    if (fieldset && referenceLabel.tagName.toLowerCase() === 'legend') {
      referenceLabel.parentNode.insertBefore(panel, referenceLabel.nextSibling);
    } else {
      const durabilityGroup = referenceLabel ? referenceLabel.closest('div[role="group"]') : null;
      if (durabilityGroup && durabilityGroup.parentNode) {
        durabilityGroup.parentNode.insertBefore(panel, durabilityGroup.nextSibling);
      } else if (referenceLabel && referenceLabel.parentNode) {
        referenceLabel.parentNode.insertBefore(panel, referenceLabel.nextSibling);
      } else {
        document.body.appendChild(panel);
      }
    }
    return panel;
  }

  // Use event delegation to handle clicks on the durability info toggle
  document.addEventListener('click', function(e) {
    // Handle JavaScript-created icon (both Infinite Options and native variant picker)
    if (e.target && (e.target.id === 'durability-info-toggle' || e.target.closest('#durability-info-toggle'))) {
      e.preventDefault();
      e.stopPropagation();
      // Look for panel in both Infinite Options and native variant picker contexts
      const durabilityLabel = document.querySelector('#infiniteoptions-container label[id*="Durability Upgrade"], #infiniteoptions-container label.spb-productdescfont[id*="Durability Upgrade"]')
        || document.querySelector('fieldset[data-option-name="Durability Upgrade"] legend');
      const panel = getOrCreateInfoPanel(durabilityLabel);
      toggleInfo(panel);
      return;
    }

    // Handle CSS pseudo-element icon (fallback)
    const durabilityLabel = e.target.closest('label[id*="Durability Upgrade"]') ||
                           e.target.closest('label.spb-productdescfont[id*="Durability Upgrade"]');
    if (durabilityLabel) {
      // Check if click is in the icon area (right side of label)
      const rect = durabilityLabel.getBoundingClientRect();
      const clickX = e.clientX - rect.left;
      const labelWidth = rect.width;

      if (clickX > labelWidth - 30) { // Icon area
        e.preventDefault();
        e.stopPropagation();
        const panel = getOrCreateInfoPanel(durabilityLabel);
        toggleInfo(panel);
      }
    }
  }, true); // Use capture phase


  // Helper to create and attach the info icon and panel to a target element
  function attachInfoToggle(targetEl, insertAfterEl) {
    // Skip if already has info toggle
    if (targetEl.querySelector('#durability-info-toggle')) {
      return;
    }

    // Create the info toggle container (like sizing-info-container)
    const infoToggleContainer = document.createElement('span');
    infoToggleContainer.className = 'durability-info-container';
    infoToggleContainer.id = 'durability-info-toggle';
    infoToggleContainer.style.cssText = `
      margin-left: 8px;
      cursor: pointer;
      display: inline-flex;
      align-items: center;
    `;

    // Create the info icon: small circle with i, black border, white background
    const infoIcon = document.createElement('span');
    infoIcon.className = 'durability-info-icon';
    infoIcon.textContent = 'i';
    infoIcon.style.cssText = `
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 18px;
      height: 18px;
      line-height: 18px;
      font-size: 12px;
      font-weight: 600;
      color: #000;
      background: #fff;
      border: 1px solid #000;
      border-radius: 50%;
      text-transform: none;
      letter-spacing: 0;
    `;

    infoToggleContainer.appendChild(infoIcon);

    // Add the toggle to the target element
    targetEl.appendChild(infoToggleContainer);

    // Create the info content div (like sizing-info)
    const infoContent = document.createElement('div');
    infoContent.id = 'durability-info';
    infoContent.className = 'durability-info-text';
    infoContent.style.cssText = `
      display: none;
      margin-top: 6px;
      padding: 0;
      background: transparent;
      border: 0;
      border-radius: 0;
      font-size: 13px;
      line-height: 1.5;
      color: inherit;
      overflow: hidden;
    `;

    // Set content from settings (intro + three options)
    infoContent.innerHTML = buildInfoContentHTML();

    // Insert the info content after the specified element
    if (insertAfterEl && insertAfterEl.parentNode) {
      insertAfterEl.parentNode.insertBefore(infoContent, insertAfterEl.nextSibling);
    } else {
      targetEl.parentNode.insertBefore(infoContent, targetEl.nextSibling);
    }
  }

  // Set up info toggle for native variant picker (fieldset-based)
  function setupNativeVariantToggle() {
    const fieldset = document.querySelector('fieldset[data-option-name="Durability Upgrade"]');
    if (!fieldset) return false;

    const legend = fieldset.querySelector('legend');
    if (!legend) return false;

    // Already set up
    if (legend.querySelector('#durability-info-toggle')) return true;

    // Insert info panel after the legend but inside the fieldset
    attachInfoToggle(legend, legend);
    return true;
  }

  // Function to set up the info icon and content (Infinite Options path)
  function setupDurabilityInfoToggle(_retryCount = 0) {
    const MAX_RETRIES = 20;
    const RETRY_DELAY = 300;

    // First try native variant picker
    if (setupNativeVariantToggle()) {
      return;
    }

    // Then try Infinite Options container
    const container = document.getElementById('infiniteoptions-container');
    if (!container) {
      if (_retryCount < MAX_RETRIES) {
        setTimeout(() => setupDurabilityInfoToggle(_retryCount + 1), RETRY_DELAY);
      }
      return;
    }

    // Find the durability upgrade label with multiple methods
    let durabilityLabel = container.querySelector('label[id*="Durability Upgrade"]');
    if (!durabilityLabel) {
      durabilityLabel = container.querySelector('label.spb-productdescfont[id*="Durability Upgrade"]');
    }
    if (!durabilityLabel) {
      // Try to find any likely title element that mentions durability
      const candidates = container.querySelectorAll('label, legend, .spb-label-tooltip label, .spb-label-tooltip, .spb-productdescfont, [role="group"] > label:first-child, [class*="label"], [class*="title"], [class*="heading"]');
      for (let i = 0; i < candidates.length; i++) {
        const el = candidates[i];
        if ((el.textContent || '').toLowerCase().includes('durability')) {
          durabilityLabel = el.tagName.toLowerCase() === 'label' ? el : el.querySelector('label') || el;
          break;
        }
      }
    }

    if (!durabilityLabel) {
      if (_retryCount < MAX_RETRIES) {
        setTimeout(() => setupDurabilityInfoToggle(_retryCount + 1), RETRY_DELAY);
      }
      return;
    }

    // Attach using Infinite Options structure
    const durabilityGroup = durabilityLabel.closest('div[role="group"]');
    attachInfoToggle(durabilityLabel, durabilityGroup || durabilityLabel);
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setupDurabilityInfoToggle());
  } else {
    setupDurabilityInfoToggle();
  }

  // Set up a mutation observer to handle dynamic content changes (like Infinite Options)
  const observer = new MutationObserver(function(mutations) {
    for (let mutation of mutations) {
      if (mutation.type === 'childList') {
        const hasInfiniteOptions = mutation.target.id === 'infiniteoptions-container' ||
                                  (mutation.target.querySelector && mutation.target.querySelector('#infiniteoptions-container'));

        if (hasInfiniteOptions) {
          setTimeout(setupDurabilityInfoToggle, 100);
          break;
        }
      }
    }
  });

  // Start observing
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: false
  });

  // Listen for variant change events
  document.addEventListener('variant:change', function() {
    setTimeout(setupDurabilityInfoToggle, 200);
  });

})();
